import { render, staticRenderFns } from "./LabelChip.vue?vue&type=template&id=dcb38fa8&scoped=true&"
import script from "./LabelChip.vue?vue&type=script&lang=js&"
export * from "./LabelChip.vue?vue&type=script&lang=js&"
import style0 from "./LabelChip.vue?vue&type=style&index=0&id=dcb38fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb38fa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcb38fa8')) {
      api.createRecord('dcb38fa8', component.options)
    } else {
      api.reload('dcb38fa8', component.options)
    }
    module.hot.accept("./LabelChip.vue?vue&type=template&id=dcb38fa8&scoped=true&", function () {
      api.rerender('dcb38fa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/LabelChip.vue"
export default component.exports